import React from "react";
import { injectIntl } from "react-intl";


const RegisterMetaBlock = ({ intl }) => {
  return (
    <div className="meta-content full-bleed--s full-bleed--m bg-brand--off-white w-auto mb-none">
      <div>
				<h3 className="meta-content__section-title">{intl.formatMessage({id: 'RegisterMetaBlock.Title'})}</h3>
        <p>{intl.formatMessage({id: 'RegisterMetaBlock.Description'})}:</p>
				<ul className="body-copy list--checks">
					<li>{intl.formatMessage({id: 'RegisterMetaBlock.ListItemOne'})}</li>
					<li>{intl.formatMessage({id: 'RegisterMetaBlock.ListItemTwo'})}</li>
					<li>{intl.formatMessage({id: 'RegisterMetaBlock.ListItemThree'})}</li>
					<li>{intl.formatMessage({id: 'RegisterMetaBlock.ListItemFour'})}</li>
				</ul>

        <div className="mt-m">
          <img src='/myrandstad-app/assets/image/register/feather_pen.svg' alt={intl.formatMessage({id: 'RegisterMetaBlock.Title'})}/>
        </div>
			</div>
		</div>
  );
};

export default injectIntl(RegisterMetaBlock);
